import React from 'react'
import './index.css'

function ForsageTitleSm() {
    return (
        <div className='forsage-title-sm'>
            <span id='forsage-tilte-id'>ID 843032 / &nbsp;</span>
            <span id='forsage-tilte-por-tres'> &nbsp;Forsage x3 &nbsp;</span>
            <span id='forsage-tilte-levels'>(2 out of 12 levels)</span>
        </div>
    )
}

export default ForsageTitleSm